import EA from '../helpers/init';
import { Swiper } from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default EA.Methods.swiper3 = ($this) => {
    const swiper = $this.querySelector('.swiper3');
    const nextBtn = $this.querySelector('.blog-detail-nxt-slide');
    const prevBtn = $this.querySelector('.blog-detail-prev-slide');

    if (!swiper) return;

    const relatedSwiper = new Swiper(swiper, {
        modules: [
            Pagination,
            Navigation,
        ],

        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },

        speed: 1050,
        slidesPerView: 1.05,
        spaceBetween: 32,
        

        breakpoints: {
            600: {
                slidesPerView: 'auto',
                spaceBetween: 24,
            },
        },

        centerInsufficientSlides: true,
        watchOverflow: false,
        watchSlidesProgress: true,

        //  loop: true,

        
    });

    relatedSwiper.slides.forEach((slide, index) => {
        slide.addEventListener('focusin', () => {
            relatedSwiper.slideTo(index);
        });
    });
   
};